import { type ComponentType } from 'react';
import { HeroBand, HeroBandCompact } from './HeroBand';
import { AiAskBar } from './AiAskBar';
import { VitalSigns } from './VitalSigns';
import { FunZone } from './FunZone';
import { ForYou } from './ForYou';
import { OnYourMind } from './OnYourMind';
import { NewsStrip } from './NewsStrip';
import { BLOCK_IDS, type BlockId } from './types';

export interface BlockMeta {
  id: BlockId;
  label: string;
  description: string;
  // Whether this block requires a value-injecting parent (e.g. pinned, all-apps).
  // Those render in Home.tsx itself and are NOT in this registry.
  componentName: string;
}

// Stateless blocks renderable anywhere — no extra props required.
export const STANDALONE_BLOCK_COMPONENTS: Partial<Record<BlockId, ComponentType>> = {
  hero: HeroBand,
  'ai-ask': AiAskBar,
  'vital-signs': VitalSigns,
  'fun-zone': FunZone,
  'for-you': ForYou,
  'on-your-mind': OnYourMind,
  news: NewsStrip,
};

// Compact variants used by Focused variant where we want a slimmer chrome.
export const COMPACT_VARIANTS: Partial<Record<BlockId, ComponentType>> = {
  hero: HeroBandCompact,
};

export const BLOCK_META: Record<BlockId, BlockMeta> = {
  hero:            { id: 'hero',            label: 'Hero band',           description: 'Greeting, time, weather, thought of the day.',     componentName: 'HeroBand' },
  'ai-ask':        { id: 'ai-ask',          label: 'Ask OneDesk',         description: 'The AI assistant — currently a preview.',         componentName: 'AiAskBar' },
  'vital-signs':   { id: 'vital-signs',     label: 'Vital signs',         description: 'Calendar, inbox, SLA, leave — at-a-glance.',      componentName: 'VitalSigns' },
  'fun-zone':      { id: 'fun-zone',        label: 'Fun zone',            description: 'Daily puzzle + top scorer.',                       componentName: 'FunZone' },
  'for-you':       { id: 'for-you',         label: 'For you',             description: 'Announcements, birthdays, who is out.',           componentName: 'ForYou' },
  'on-your-mind':  { id: 'on-your-mind',    label: 'On your mind',        description: 'Sticky notes and reminders. Coming soon.',         componentName: 'OnYourMind' },
  news:            { id: 'news',            label: 'Local news',          description: 'Headlines for your country.',                      componentName: 'NewsStrip' },
  announcements:   { id: 'announcements',   label: 'Announcements',       description: 'Active org-wide announcements.',                   componentName: 'Announcements' },
  'whats-new':     { id: 'whats-new',       label: "What's new",          description: 'New feature tours surfaced since you last looked.',componentName: 'WhatsNew' },
  pinned:          { id: 'pinned',          label: 'Pinned apps',         description: 'Drag-to-reorder. The apps you launch most.',       componentName: 'PinnedApps' },
  'all-apps-link': { id: 'all-apps-link',   label: 'Browse all apps →',   description: 'Compact link to the full app catalogue.',          componentName: 'AllAppsLink' },
  'all-apps-grid': { id: 'all-apps-grid',   label: 'All apps grid',       description: 'Full grid of every app. (Classic look.)',          componentName: 'AllAppsGrid' },
};

export const ALL_BLOCK_IDS = BLOCK_IDS;
